import React from 'react';
import { BlockMath } from 'react-katex';

const FormulaCard = ({ title, formula, variables, note }) => (
  <div
    data-testid="formula-card"
    className="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-lg p-5 flex flex-col gap-3"
  >
    {title && (
      <p className="text-xs font-semibold uppercase tracking-widest text-teal-700 dark:text-teal-400">
        {title}
      </p>
    )}
    <div className="overflow-x-auto py-1">
      <BlockMath math={formula} />
    </div>
    {variables && (
      <ul className="space-y-1 border-t border-slate-200 dark:border-slate-700 pt-3">
        {variables.map(({ sym, desc }) => (
          <li key={sym} className="flex gap-2 text-xs text-slate-600 dark:text-slate-400">
            <code className="text-teal-700 dark:text-teal-400 font-mono font-medium min-w-[60px]">
              {sym}
            </code>
            <span>{desc}</span>
          </li>
        ))}
      </ul>
    )}
    {note && (
      <p className="text-xs text-slate-500 dark:text-slate-500 italic border-t border-slate-200 dark:border-slate-700 pt-2">
        {note}
      </p>
    )}
  </div>
);

export default FormulaCard;
